// 健康档案
const HealthDoc = r => require.ensure([], () => r(require('./')), 'HealthDoc')
// 档案列表
const HealthDocList = r => require.ensure([], () => r(require('./healthdoc-list')), 'HealthDocList')
// 档案详情
const healthdocDetail = r => require.ensure([], () => r(require('./healthdoc-detail')), 'healthdocDetail')
// 完善资料
const healthdocEdit = r => require.ensure([], () => r(require('./healthdoc-edit')), 'healthdocEdit')
// 其他报告列表
const otherReportList = r => require.ensure([], () => r(require('./other-report')), 'otherReportList')

export default {
  path: '/healthdoc',
  component: HealthDoc,
  meta: { title: '健康档案' },
  redirect: '/healthdoc/list',
  children: [
    {
      path: 'list',
      name: 'HealthDocList',
      meta: { title: '档案列表' },
      component: HealthDocList
    },
    {
      path: 'detail',
      name: 'healthdocDetail',
      meta: { title: '档案详情' },
      component: healthdocDetail
    },
    {
      path: 'edit',
      name: 'healthdocEdit',
      meta: { title: '完善资料' },
      component: healthdocEdit
    },
    {
      path: 'other/report',
      name: 'otherReportList',
      meta: { title: '健康记录' },
      component: otherReportList
    }
  ]
}



// WEBPACK FOOTER //
// ./src/views/healthdoc/router.js